module.exports = __webpack_public_path__ + "static/media/Neck_2.266e9a9d.jpg";